import moment from "moment";

export const isDate = (value) => {
  return Boolean(
    value?.toISOString?.() || 
    (!Number(value) &&
    moment(value, moment.ISO_8601, true).isValid()));
}
